<template>
  <my-modal :visible="customerVisible" width="w-4/6" hide-actions>
    <my-table
      :data="data"
      :query="query"
      :editable="false"
      :loading="loading"
      selectType="single"
      v-model:selectedRow="selectedRow"
      @search="handleSearch"
      @refresh="handleRefresh"
      @edit="handleEdit"
      @change-page="handleChangePage"
      @change-limit="handleChangeLimit"
      :headers="headers">
      <template v-slot:title>
        <h3 class="font-bold text-lg">Үйлчүүлэгчийн гэрээний жагсаалт</h3>
      </template>
      <template v-slot:footer>
        <div class="space-x-4">
          <my-button type="primary" @click="handleCreate" icon="plus" title="Шинээр гэрээ бүртгэх"></my-button>
          <my-button type="success" @click="handleSelect" icon="check" title="Үйлчлүүлэгч дээр гэрээ бүртгэх"></my-button>
          <my-button @click="customer_cancel" icon="x" title="Цуцлах, Хаах"></my-button>
        </div>
      </template>
    </my-table>
  </my-modal>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import listMethods from '../../utils/listMethods'
import listData from '../../utils/listData'
export default {
  data () {
    return {
      ...listData,
      name: 'all',
      listApiUrl: '/contracts',
      headers: [{
        name: 'regNo',
        caption: 'Гэрээний дугаар',
        width: '90px'
      }, {
        name: 'createdAt',
        caption: 'Огноо',
        type: 'Date',
        width: '120px'
      }, {
        name: 'status.name',
        caption: 'Төлөв',
        width: '140px'
      }, {
        name: 'customer.registerNum',
        caption: 'Регистрийн дугаар',
        width: '140px'
      }, {
        name: 'customer.lastName',
        caption: 'Овог'
      }, {
        name: 'customer.firstName',
        caption: 'Нэр'
      }],
      selectedRow: null,
      query: {
        name: 'all',
        page: 1,
        limit: 10,
        search: [],
        sort: [{ name: 'createdAt', type: 'DESC' }]
      }
    }
  },
  computed: {
    ...mapGetters(['customerVisible', 'customerRegisterNum', 'customerText'])
  },
  watch: {
    customerVisible (val) {
      if (val) {
        this.selectedRow = null
        if (this.customerText) {
          this.query.search = [{ name: 'text', value: this.customerText }]
        } else {
          this.query.search = [{ name: 'customer.registerNum', value: this.customerRegisterNum }]
        }
        this.data = [[], 0]
        this.handleSearch()
      }
    }
  },
  methods: {
    ...listMethods,
    ...mapActions(['customer_select', 'customer_cancel']),
    handleRefresh () {
      this.data = [[], 0]
      this.query.search = []
      this.handleSearch()
    },
    handleSearch () {
      if (!this.query.search.some(c => !!c.value)) {
        this.data = [[], 0]
        return
      }
      this.getList()
    },
    handleEdit (id) {
      if (this.$route.name === 'contracts-detail') {
        this.$router.push({ name: 'contracts-detail', params: { id } })
      } else {
        this.$router.push({ name: 'contracts-detail', params: { name: 'all', id } })
      }
      this.customer_cancel()
    },
    handleCreate () {
      this.$router.push({ name: 'contracts-detail', params: { name: 'all', id: 'create' } })
      this.customer_cancel()
    },
    handleSelect () {
      try {
        if (!this.selectedRow) {
          this.customError('Мөр сонгоно уу!')
        }
        this.customer_select(this.selectedRow.customer)
      } catch (err) {
        this.handleError(err)
      }
    }
  }
}
</script>
